export const HOST = "http://114.55.128.217";

export const DOMAIN = "http://114.55.128.217";

export const SERVERPATH = "/admin";

export const UPLOAD_FILE_URL = `${SERVERPATH}/System/uploadFile`;

export const USERINFO = "userInfo";

export const GOODS_LIST_CACHE_KEY = "MarketGoodsListCache";

export default {
  HOST,
  SERVERPATH,
  UPLOAD_FILE_URL,
  USERINFO,
  GOODS_LIST_CACHE_KEY
};
